import {Authority} from "@/shared/security/authority";

const Login = () => import('@/account/login/login.vue');
const Dashboard = () => import('@/pages/dashboard/dashboard.vue');
const LandingContact = () => import('@/pages/landing-contact/landing-contact.vue');
const ContactUs = () => import('@/pages/contact-us/contact-us.vue');
const Contact3 = () => import('@/pages/investment-contact/investment-contact.vue');
const News = () => import('@/pages/news/news.vue');
const Careers = () => import('@/pages/career/career.vue');
const JobApplications = () => import('@/pages/job-applications/job-applications.vue');
const ProductContact = () => import('@/pages/product-contact/product-contact.vue');
const SoftwareContact = () => import('@/pages/software-contact/software-contact.vue');
const ServiceContact = () => import('@/pages/service-contact/service-contact.vue');
const Articles = () => import('@/pages/articles/article.vue');
const Products = () => import('@/pages/products/products.vue');
const UserManagement = () => import('@/account/user-management/user-management.vue');
const RegistrationMail = () => import('@/pages/registration-mails/registration-mails.vue');

export default [
    {
        path: '/',
        name: 'Login',
        component: Login,
    },
    {
        path: '/user-management',
        name: 'UserManagement',
        component: UserManagement,
        meta: { authorities: [Authority.ADMIN] },
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
    },
    {
        path: '/landing-contact',
        name: 'LandingContact',
        component: LandingContact,
    },
    {
        path: '/product-contact',
        name: 'ProductContact',
        component: ProductContact,
    },
    {
        path: '/software-contact',
        name: 'SoftwareContact',
        component: SoftwareContact,
    },
    {
        path: '/service-contact',
        name: 'ServiceContact',
        component: ServiceContact,
    },
    {
        path: '/contact-us',
        name: 'ContactUs',
        component: ContactUs,
    },
    {
        path: '/investment-contact',
        name: 'ContactUs3',
        component: Contact3,
    },
    {
        path: '/news',
        name: 'News',
        component: News,
    },
    {
        path: '/careers',
        name: 'Careers',
        component: Careers,
    },
    {
        path: '/job-applications',
        name: 'JobApplications',
        component: JobApplications,
    },
    {
        path: '/articles',
        name: 'Articles',
        component: Articles,
    },
    {
        path: '/products',
        name: 'Products',
        component: Products,
    },
    {
        path: '/registration-mails',
        name: 'RegistrationMails',
        component: RegistrationMail,
    },
];
